import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const CursusPlanner = () => {
  const { gebruiker } = useAuth();
  const [cursussen, setCursussen] = useState([]);
  const [monteurs, setMonteurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedCursus, setSelectedCursus] = useState(null);
  const [editGroep, setEditGroep] = useState(null);
  const openEdit = (groep) => setEditGroep({
    ids: groep.ids, naam: groep.naam, uitgever: groep.uitgever || '',
    gepland_op: groep.gepland_op ? String(groep.gepland_op).split('T')[0] : '',
    start_tijd: groep.start_tijd || '', locatie_adres: groep.locatie_adres || '', locatie_url: groep.locatie_url || ''
  });
  const saveEdit = async () => {
    if (!editGroep.naam) { alert('Cursus naam is verplicht'); return; }
    if (!editGroep.gepland_op) { alert('Datum is verplicht'); return; }
    try {
      for (const cid of editGroep.ids) {
        await api.put('/cursussen/' + cid, {
          naam: editGroep.naam, uitgever: editGroep.uitgever || null,
          gepland_op: editGroep.gepland_op, start_tijd: editGroep.start_tijd || null,
          locatie_adres: editGroep.locatie_adres || null, locatie_url: editGroep.locatie_url || null,
          behaald_op: null, verloopt_op: null, certificaat_nummer: null, notities: null
        });
      }
      setEditGroep(null);
      loadData();
    } catch (err) { alert('Fout bij opslaan'); console.error(err); }
  };

  const [nieuweCursus, setNieuweCursus] = useState({
    naam: '',
    uitgever: '',
    gepland_op: '',
    herhaling: 'geen',
    herhaling_interval: 1,
    herhaling_aantal: 1,
    geselecteerdeMonteurs: [],
    start_tijd: '',
    locatie_adres: '',
    locatie_url: ''
  });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [cursusRes, monteursRes] = await Promise.all([
        api.get('/cursussen/alle'),
        api.get('/gebruikers')
      ]);
      setCursussen(cursusRes.data.data || []);
      const alleMonteurs = (monteursRes.data.gebruikers || []).filter(g => g.in_planning);
      setMonteurs(alleMonteurs);
      setLoading(false);
    } catch (err) {
      console.error('Fout laden:', err);
      setLoading(false);
    }
  };

  const toggleMonteur = (id) => {
    setNieuweCursus(prev => {
      const sel = prev.geselecteerdeMonteurs;
      if (sel.includes(id)) {
        return { ...prev, geselecteerdeMonteurs: sel.filter(m => m !== id) };
      }
      return { ...prev, geselecteerdeMonteurs: [...sel, id] };
    });
  };

  const selectAll = () => {
    setNieuweCursus(prev => ({
      ...prev,
      geselecteerdeMonteurs: prev.geselecteerdeMonteurs.length === monteurs.length ? [] : monteurs.map(m => m.id)
    }));
  };

  const planCursus = async () => {
    if (!nieuweCursus.naam) { alert('Cursus naam is verplicht'); return; }
    if (!nieuweCursus.gepland_op) { alert('Datum is verplicht'); return; }
    if (nieuweCursus.geselecteerdeMonteurs.length === 0) { alert('Selecteer minimaal 1 monteur'); return; }

    try {
      const datums = [nieuweCursus.gepland_op];

      // Herhalingen berekenen
      if (nieuweCursus.herhaling !== 'geen' && nieuweCursus.herhaling_aantal > 1) {
        for (let i = 1; i < nieuweCursus.herhaling_aantal; i++) {
          const vorige = new Date(datums[datums.length - 1]);
          if (nieuweCursus.herhaling === 'wekelijks') vorige.setDate(vorige.getDate() + 7 * nieuweCursus.herhaling_interval);
          else if (nieuweCursus.herhaling === 'maandelijks') vorige.setMonth(vorige.getMonth() + nieuweCursus.herhaling_interval);
          else if (nieuweCursus.herhaling === 'jaarlijks') vorige.setFullYear(vorige.getFullYear() + nieuweCursus.herhaling_interval);
          datums.push(vorige.toISOString().split('T')[0]);
        }
      }

      // Voor elke monteur en elke datum een cursus record aanmaken
      let count = 0;
      for (const monteurId of nieuweCursus.geselecteerdeMonteurs) {
        for (const datum of datums) {
          await api.post('/cursussen', {
            gebruiker_id: monteurId,
            naam: nieuweCursus.naam,
            uitgever: nieuweCursus.uitgever,
            gepland_op: datum,
            start_tijd: nieuweCursus.start_tijd || null,
            locatie_adres: nieuweCursus.locatie_adres || null,
            locatie_url: nieuweCursus.locatie_url || null,
            behaald_op: null,
            verloopt_op: null,
            certificaat_nummer: null,
            notities: null
          });
          count++;
        }
      }

      alert(count + ' cursus(sen) ingepland!');
      setNieuweCursus({ naam: '', uitgever: '', gepland_op: '', herhaling: 'geen', herhaling_interval: 1, herhaling_aantal: 1, geselecteerdeMonteurs: [], start_tijd: '', locatie_adres: '', locatie_url: '' });
      setShowModal(false);
      loadData();
    } catch (err) {
      alert('Fout bij inplannen');
      console.error(err);
    }
  };

  const deleteCursus = async (id) => {
    if (!window.confirm('Cursus verwijderen?')) return;
    try {
      await api.delete('/cursussen/' + id);
      loadData();
    } catch (err) { alert('Fout bij verwijderen'); }
  };

  // Groepeer cursussen per naam + datum
  const gegroepeerd = {};
  cursussen.forEach(c => {
    const key = c.naam + '|' + (c.gepland_op || 'onbekend');
    if (!gegroepeerd[key]) {
      gegroepeerd[key] = { naam: c.naam, uitgever: c.uitgever, gepland_op: c.gepland_op, start_tijd: c.start_tijd, locatie_adres: c.locatie_adres, locatie_url: c.locatie_url, monteurs: [], ids: [] };
    }
    const monteur = monteurs.find(m => m.id === c.gebruiker_id);
    gegroepeerd[key].monteurs.push((monteur ? monteur.voornaam + ' ' + monteur.achternaam : 'Onbekend') + (c.geaccepteerd_op ? ' ✅' : c.gezien_op ? ' 👁' : ''));
    gegroepeerd[key].ids.push(c.id);
  });

  const inputStyle = { width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '13px', color: '#6b7280', marginBottom: '4px', fontWeight: '500' };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Laden...</div>;

  return (
    <div>
      <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>🎓 Cursus Planner</h1>
        <button onClick={() => setShowModal(true)} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#3b82f6', color: 'white', cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}>+ Cursus Inplannen</button>
      </div>

      {/* Geplande cursussen overzicht */}
      <div style={{ background: 'white', borderRadius: '8px', padding: '20px', border: '1px solid #e5e7eb' }}>
        <h2 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>📅 Geplande Cursussen</h2>

        {Object.keys(gegroepeerd).length === 0 ? (
          <p style={{ textAlign: 'center', color: '#9ca3af', padding: '40px' }}>Nog geen cursussen ingepland</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {Object.values(gegroepeerd)
              .sort((a, b) => {
                if (!a.gepland_op) return 1;
                if (!b.gepland_op) return -1;
                return new Date(a.gepland_op) - new Date(b.gepland_op);
              })
              .map((groep, idx) => {
                const isPast = groep.gepland_op && new Date(groep.gepland_op) < new Date();
                return (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', background: isPast ? '#f9fafb' : '#f0fdf4', borderRadius: '8px', borderLeft: '4px solid ' + (isPast ? '#9ca3af' : '#10b981') }}>
                    <div style={{ flex: '0 0 100px', textAlign: 'center' }}>
                      {groep.gepland_op ? (
                        <div>
                          <div style={{ fontSize: '20px', fontWeight: '700', color: isPast ? '#9ca3af' : '#10b981' }}>
                            {new Date(groep.gepland_op).getDate()}
                          </div>
                          <div style={{ fontSize: '12px', color: '#6b7280' }}>
                            {new Date(groep.gepland_op).toLocaleDateString('nl-NL', { month: 'short', year: 'numeric' })}
                          </div>
                        </div>
                      ) : (
                        <span style={{ fontSize: '13px', color: '#9ca3af' }}>Geen datum</span>
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: '600', color: '#111827', fontSize: '15px' }}>🎓 {groep.naam}</div>
                      {groep.uitgever && <div style={{ fontSize: '12px', color: '#6b7280' }}>{groep.uitgever}</div>}
                      <div style={{ fontSize: '13px', color: '#374151', marginTop: '4px' }}>
                        👥 {groep.monteurs.join(', ')}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      <span style={{ padding: '3px 10px', borderRadius: '10px', fontSize: '12px', fontWeight: '500', background: isPast ? '#f3f4f6' : '#d1fae5', color: isPast ? '#6b7280' : '#065f46' }}>
                        {isPast ? 'Afgelopen' : 'Gepland'}
                      </span>
                      <button onClick={() => openEdit(groep)} style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #bfdbfe', background: '#eff6ff', cursor: 'pointer', fontSize: '12px', color: '#2563eb' }} title="Bewerken">✏️</button>
                      <button onClick={() => groep.ids.forEach(id => deleteCursus(id))} style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #fecaca', background: '#fef2f2', cursor: 'pointer', fontSize: '12px', color: '#dc2626' }} title="Verwijder alle">🗑️</button>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>

      {editGroep && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }} onClick={() => setEditGroep(null)}>
          <div style={{ background: 'white', borderRadius: '8px', width: '100%', maxWidth: '560px', maxHeight: '90vh', overflow: 'auto' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #e5e7eb' }}>
              <h2 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>✏️ Cursus Bewerken</h2>
              <button onClick={() => setEditGroep(null)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#6b7280' }}>×</button>
            </div>
            <div style={{ padding: '20px', display: 'grid', gap: '16px' }}>
              <div style={{ fontSize: '13px', color: '#6b7280', background: '#f9fafb', padding: '8px 12px', borderRadius: '6px' }}>
                👥 Geldt voor: {editGroep.ids.length} monteur(s) in deze groep
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Cursus naam *</label>
                  <input type="text" value={editGroep.naam} onChange={e => setEditGroep({...editGroep, naam: e.target.value})} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Uitgever / Instituut</label>
                  <input type="text" value={editGroep.uitgever} onChange={e => setEditGroep({...editGroep, uitgever: e.target.value})} style={inputStyle} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Datum *</label>
                  <input type="date" value={editGroep.gepland_op} onChange={e => setEditGroep({...editGroep, gepland_op: e.target.value})} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Starttijd</label>
                  <input type="time" value={editGroep.start_tijd} onChange={e => setEditGroep({...editGroep, start_tijd: e.target.value})} style={inputStyle} />
                </div>
              </div>
              <div>
                <label style={labelStyle}>Locatie (adres)</label>
                <input type="text" value={editGroep.locatie_adres} onChange={e => setEditGroep({...editGroep, locatie_adres: e.target.value})} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Locatie (link)</label>
                <input type="text" value={editGroep.locatie_url} onChange={e => setEditGroep({...editGroep, locatie_url: e.target.value})} placeholder="https://maps.google.com/..." style={inputStyle} />
              </div>
              <div style={{ fontSize: '12px', color: '#9ca3af' }}>De betrokken monteur(s) krijgen automatisch een pushmelding van de wijziging.</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', padding: '16px 20px', borderTop: '1px solid #e5e7eb' }}>
              <button onClick={() => setEditGroep(null)} style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>Annuleren</button>
              <button onClick={saveEdit} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#3b82f6', color: 'white', cursor: 'pointer', fontWeight: '500' }}>Opslaan</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Cursus inplannen */}
      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }} onClick={() => setShowModal(false)}>
          <div style={{ background: 'white', borderRadius: '8px', width: '100%', maxWidth: '560px', maxHeight: '90vh', overflow: 'auto' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #e5e7eb' }}>
              <h2 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>🎓 Cursus Inplannen</h2>
              <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#6b7280' }}>×</button>
            </div>
            <div style={{ padding: '20px', display: 'grid', gap: '16px' }}>
              {/* Cursus info */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Cursus naam *</label>
                  <input type="text" value={nieuweCursus.naam} onChange={e => setNieuweCursus({...nieuweCursus, naam: e.target.value})} placeholder="bijv. VCA Basis" style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Uitgever / Instituut</label>
                  <input type="text" value={nieuweCursus.uitgever} onChange={e => setNieuweCursus({...nieuweCursus, uitgever: e.target.value})} placeholder="bijv. SSVV" style={inputStyle} />
                </div>
              </div>

              {/* Datum */}
              <div>
                <label style={labelStyle}>📅 Datum *</label>
                <input type="date" value={nieuweCursus.gepland_op} onChange={e => setNieuweCursus({...nieuweCursus, gepland_op: e.target.value})} style={inputStyle} />
                <label style={labelStyle}>🕒 Start-tijd</label>
                <input type="time" value={nieuweCursus.start_tijd} onChange={e => setNieuweCursus({...nieuweCursus, start_tijd: e.target.value})} style={inputStyle} />
                <label style={labelStyle}>📍 Locatie (adres)</label>
                <input type="text" placeholder="bijv. Westpoort 22, Amsterdam" value={nieuweCursus.locatie_adres} onChange={e => setNieuweCursus({...nieuweCursus, locatie_adres: e.target.value})} style={inputStyle} />
                <label style={labelStyle}>🗺️ Google Maps link (optioneel)</label>
                <input type="text" placeholder="laat leeg → wordt automatisch uit adres" value={nieuweCursus.locatie_url} onChange={e => setNieuweCursus({...nieuweCursus, locatie_url: e.target.value})} style={inputStyle} />
              </div>

              {/* Herhaling */}
              <div style={{ background: '#f9fafb', borderRadius: '8px', padding: '12px' }}>
                <label style={labelStyle}>🔁 Herhaling</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px', marginTop: '8px' }}>
                  <select value={nieuweCursus.herhaling} onChange={e => setNieuweCursus({...nieuweCursus, herhaling: e.target.value})} style={inputStyle}>
                    <option value="geen">Geen herhaling</option>
                    <option value="wekelijks">Wekelijks</option>
                    <option value="maandelijks">Maandelijks</option>
                    <option value="jaarlijks">Jaarlijks</option>
                  </select>
                  {nieuweCursus.herhaling !== 'geen' && (
                    <>
                      <div>
                        <label style={{ fontSize: '11px', color: '#6b7280' }}>Elke X keer</label>
                        <input type="number" min="1" value={nieuweCursus.herhaling_interval} onChange={e => setNieuweCursus({...nieuweCursus, herhaling_interval: parseInt(e.target.value) || 1})} style={inputStyle} />
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', color: '#6b7280' }}>Aantal keer</label>
                        <input type="number" min="1" max="52" value={nieuweCursus.herhaling_aantal} onChange={e => setNieuweCursus({...nieuweCursus, herhaling_aantal: parseInt(e.target.value) || 1})} style={inputStyle} />
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Monteur selectie */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <label style={{ ...labelStyle, marginBottom: 0 }}>👥 Monteurs selecteren *</label>
                  <button onClick={selectAll} style={{ padding: '4px 10px', borderRadius: '4px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer', fontSize: '12px' }}>
                    {nieuweCursus.geselecteerdeMonteurs.length === monteurs.length ? 'Deselecteer alle' : 'Selecteer alle'}
                  </button>
                </div>
                <div style={{ maxHeight: '200px', overflow: 'auto', border: '1px solid #e5e7eb', borderRadius: '6px' }}>
                  {monteurs.map(m => (
                    <div key={m.id} onClick={() => toggleMonteur(m.id)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 12px', cursor: 'pointer', background: nieuweCursus.geselecteerdeMonteurs.includes(m.id) ? '#eff6ff' : 'white', borderBottom: '1px solid #f3f4f6' }}>
                      <div style={{ width: '20px', height: '20px', borderRadius: '4px', border: '2px solid ' + (nieuweCursus.geselecteerdeMonteurs.includes(m.id) ? '#3b82f6' : '#d1d5db'), background: nieuweCursus.geselecteerdeMonteurs.includes(m.id) ? '#3b82f6' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '12px' }}>
                        {nieuweCursus.geselecteerdeMonteurs.includes(m.id) && '✓'}
                      </div>
                      <span style={{ fontWeight: '500', fontSize: '14px' }}>{m.voornaam} {m.achternaam}</span>
                    </div>
                  ))}
                </div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                  {nieuweCursus.geselecteerdeMonteurs.length} van {monteurs.length} geselecteerd
                </div>
              </div>

              {/* Samenvatting */}
              {nieuweCursus.naam && nieuweCursus.gepland_op && nieuweCursus.geselecteerdeMonteurs.length > 0 && (
                <div style={{ background: '#eff6ff', borderRadius: '8px', padding: '12px', fontSize: '13px', color: '#1e40af' }}>
                  <strong>Samenvatting:</strong> {nieuweCursus.naam} voor {nieuweCursus.geselecteerdeMonteurs.length} monteur(s)
                  {nieuweCursus.herhaling !== 'geen' ? (
                    <span> — {nieuweCursus.herhaling_aantal}x {nieuweCursus.herhaling} = <strong>{nieuweCursus.geselecteerdeMonteurs.length * nieuweCursus.herhaling_aantal}</strong> cursus records</span>
                  ) : (
                    <span> — <strong>{nieuweCursus.geselecteerdeMonteurs.length}</strong> cursus records</span>
                  )}
                </div>
              )}

              <button onClick={planCursus} style={{ padding: '12px', borderRadius: '6px', border: 'none', background: '#10b981', color: 'white', cursor: 'pointer', fontWeight: '600', fontSize: '15px' }}>
                📅 Cursus Inplannen
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CursusPlanner;
